import React from 'react'
import { FormattedMessage } from 'react-intl'

export default function Header({
  skus,
  openPriceModal
}) {
  return <>
    <h5 className="uppercase text-sky tracking-wide-2xl">
      <FormattedMessage id="booking.people.category" defaultMessage="New booking" />
    </h5>

    <h1 className="border-b pb-8 text-4xl">
      <FormattedMessage id="booking.people.header" defaultMessage="Please select passes for your party" />
      {skus && // Modal needs prices to be fetched before adding to props
      <>
        {/* <br />
        <button onClick={openPriceModal} className="inline-block text-lg underline text-grass font-normal" type="button">
          <FormattedMessage id="booking.people.pricingLink" defaultMessage="See our ski passes and pricing" />
        </button> */}
      </>
      }
      &nbsp;&nbsp;
    </h1>
  </>
}